<!--
  -- 特定项目：设备列表，选择项目后展示项目设备
-->
<template>
  <div>
    <el-form :inline="true" :model="form" size="mini">
      <el-form-item label="项目名称" prop="projectName">
        <el-select
          v-model="form.projectId"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入/选择项目名称"
          :remote-method="queryProjectList"
          :loading="projectLoading"
          @change="handleProjectChange"
          @clear="handleProjectClear"
          @visible-change="handleProjectVisibleChange"
        >
          <el-option
            v-for="item in projectList"
            :key="getProjectValue(item)"
            :label="getProjectLabel(item)"
            :value="getProjectValue(item)"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="pagedTableData"
      max-height="420"
      style="width: 100%"
      size="mini"
      :header-cell-style="{ background: '#F5F6F7' }"
    >
      <el-table-column label="设备ID" prop="deviceId">
        <template slot-scope="scope">
          {{ scope.row.deviceId || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="设备UUID" prop="deviceUuid">
        <template slot-scope="scope">
          {{ scope.row.deviceUuid || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="设备类型">
        <template slot-scope="scope">
          {{ getDeviceTypeLabel(scope.row.deviceType) }}
        </template>
      </el-table-column>
      <el-table-column label="设备名称" prop="deviceName">
        <template slot-scope="scope">
          {{ scope.row.deviceName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="家庭名称" prop="spaceName">
        <template slot-scope="scope">
          {{ scope.row.spaceName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="operation">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDeleteDevice(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
import { getProjectList, getProjectDevicePage } from "@/api/product/product-details"

export default {
  name: "specificProjectDeviceList",
  props: {
    productId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: {
        projectId: "",
        projectName: ""
      },
      loading: false,
      projectLoading: false,
      projectList: [],
      selectedProject: null,
      projectSearchTimer: null,
      projectRequestSeq: 0,
      deviceRequestSeq: 0,
      tableData: [],
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    total() {
      return this.tableData.length
    },
    pagedTableData() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.tableData.slice(start, start + this.pageSize)
    }
  },
  beforeDestroy() {
    clearTimeout(this.projectSearchTimer)
    this.projectRequestSeq++
    this.deviceRequestSeq++
  },
  methods: {
    getProjectValue(project) {
      return project?.id || ""
    },
    getProjectId(project) {
      return project?.id || ""
    },
    getProjectLabel(project) {
      return project?.projectName || "-"
    },
    getDeviceTypeLabel(deviceType) {
      if (deviceType === '1') return '子设备'
      if (deviceType === '0') return '网关设备'
      return '-'
    },
    handleProjectVisibleChange(visible) {
      if (visible) {
        this.queryProjectList("", true)
      }
    },
    queryProjectList(query, immediate = false) {
      const projectName = (query || "").trim()
      const requestSeq = ++this.projectRequestSeq

      clearTimeout(this.projectSearchTimer)

      if (immediate) {
        this.fetchProjectList(projectName, requestSeq)
        return
      }

      this.projectSearchTimer = setTimeout(() => {
        this.fetchProjectList(projectName, requestSeq)
      }, 300)
    },
    fetchProjectList(projectName, requestSeq) {
      this.projectLoading = true
      const params = projectName ? { projectName } : {}
      getProjectList(params).then(res => {
        if (requestSeq !== this.projectRequestSeq) return
        const data = res.data.data || {}
        this.projectList = data.records || (Array.isArray(data) ? data : [])
      }).catch(err => {
        if (requestSeq !== this.projectRequestSeq) return
        this.projectList = []
        this.$message.error(err.message)
      }).finally(() => {
        if (requestSeq !== this.projectRequestSeq) return
        this.projectLoading = false
      })
    },
    handleProjectChange(projectValue) {
      if (!projectValue) {
        this.handleProjectClear()
        return
      }
      const project = this.projectList.find(item => this.getProjectValue(item) === projectValue)
      if (!project) return
      this.selectedProject = project
      this.form.projectName = this.getProjectLabel(project)
      this.resetDeviceList()
      this.queryProjectDeviceList(project)
    },
    handleProjectClear() {
      this.form.projectId = ""
      this.form.projectName = ""
      this.selectedProject = null
      this.resetDeviceList()
    },
    resetDeviceList() {
      this.deviceRequestSeq++
      this.loading = false
      this.tableData = []
      this.currentPage = 1
      this.emitDeviceIdList()
    },
    // 根据选中的项目查询项目下设备，接口返回数据后在前端分页
    queryProjectDeviceList(project) {
      const requestSeq = ++this.deviceRequestSeq
      this.loading = true
      getProjectDevicePage({
        projectId: this.getProjectId(project),
        productId: this.productId
      }).then(res => {
        if (requestSeq !== this.deviceRequestSeq) return
        const data = res.data.data || {}
        this.tableData = data.records || (Array.isArray(data) ? data : [])
        this.currentPage = 1
        this.emitDeviceIdList()
      }).catch(err => {
        if (requestSeq !== this.deviceRequestSeq) return
        this.$message.error(err.message)
      }).finally(() => {
        if (requestSeq !== this.deviceRequestSeq) return
        this.loading = false
      })
    },
    handleDeleteDevice(row) {
      const deviceId = row.deviceId || row.did
      this.tableData = this.tableData.filter(item => (item.deviceId || item.did) !== deviceId)
      this.correctCurrentPage()
      this.emitDeviceIdList()
    },
    correctCurrentPage() {
      const maxPage = Math.max(Math.ceil(this.total / this.pageSize), 1)
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage
      }
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
    },
    emitDeviceIdList() {
      const deviceIdList = this.tableData
        .map(item => item.deviceId || item.did)
        .filter(Boolean)
        .join(';')
      this.$emit('update-deviceIdList', deviceIdList)
    }
  }
}
</script>
<style scoped lang="scss">

</style>
